import React, { Component, ChangeEvent, FormEvent } from 'react';
import Moment from "react-moment";
import { ArticleNode, Engine, GetSlug, State, Article } from "../../utils/core";
import { Link  } from "../../plugins/i18next/ea-react-i18next";
import * as JsSearch from 'js-search';

export default class ClientSearch extends Component<{
  articles: Article[];
  engine: Engine;
}, State> {
  state: State = {
    isLoading: true,
    searchResults: [],
    search: null,
    isError: false,
    indexByTitle: false,
    indexByAuthor: false,
    indexByContent: false,
    termFrequency: true,
    removeStopWords: false,
    searchQuery: '',
    selectedStrategy: '',
    selectedSanitizer: '',
  };

  static getDerivedStateFromProps(nextProps: {articles: ArticleNode[]; engine: Engine;}, prevState: State): Partial<State> | null {
    if (prevState.search === null) {
      const { engine } = nextProps;
      return {
        indexByTitle: engine.TitleIndex,
        indexByAuthor: engine.AuthorIndex,
        indexByContent: engine.ContentIndex,
        termFrequency: engine.SearchByTerm,
        selectedSanitizer: engine.searchSanitizer,
        selectedStrategy: engine.indexStrategy,
      };
    }
    return null;
  }

  async componentDidMount() {
    this.rebuildIndex();
  }

  rebuildIndex = (): void => {
    const {
      selectedStrategy,
      selectedSanitizer,
      removeStopWords,
      termFrequency,
      indexByTitle,
      indexByAuthor,
      indexByContent,
    } = this.state;
    const { articles } = this.props;

     const dataToSearch = new JsSearch.Search('id');
    if (removeStopWords) {
      dataToSearch.tokenizer = new JsSearch.StopWordsTokenizer(dataToSearch.tokenizer);
    }
    if (selectedStrategy === 'All') {
      dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
    }
    if (selectedStrategy === 'Exact match') {
      dataToSearch.indexStrategy = new JsSearch.ExactWordIndexStrategy();
    }
    if (selectedStrategy === 'Prefix match') {
      dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy();
    }
    selectedSanitizer === 'Case Sensitive'
      ? (dataToSearch.sanitizer = new JsSearch.CaseSensitiveSanitizer())
      : (dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer());

    termFrequency
      ? (dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex('id'))
      : (dataToSearch.searchIndex = new JsSearch.UnorderedSearchIndex());
    if (indexByTitle) {
      dataToSearch.addIndex('title');
    }
    if (indexByAuthor) {
      dataToSearch.addIndex('authorid');
    }

    if(indexByContent){
      dataToSearch.addIndex("html")
    }
    dataToSearch.addDocuments(articles);
    this.setState({ search: dataToSearch, isLoading: false });
  };

  searchData = (e: ChangeEvent<HTMLInputElement>): void => {
    const { search } = this.state;
    const queryResult = search ? search.search(e.target.value) : [];
    this.setState({ searchQuery: e.target.value, searchResults: queryResult.slice(0, 3) as ArticleNode[] });
  };

  handleSubmit = (e: FormEvent): void => {
    e.preventDefault();
  };

  render() {
    const { searchResults, searchQuery } = this.state;
    const queryResults = searchQuery !== '' ? searchResults : undefined;
   
    return (
      <div className="widget widget_search">
      <h3 className="widget-title">Search</h3>

      <div className="search-form">
         <label>
          <span className="screen-reader-text">Search for:</span>
          <input type="search" className="search-field" placeholder="Search..."
            value={searchQuery}
            onChange={this.searchData} 
             />
        </label>
          <ul className="list-group searchResults">
            {(searchQuery !== undefined) && queryResults?.map((post: ArticleNode) => (
              <li className="list-group-item" key={post.id}>
                <Link to={GetSlug(post.frontmatter.category, post.frontmatter.slug)} ><h2>{post.frontmatter.title}</h2>
                  <small><Moment format="YYYY/MM/DD">{post.frontmatter.date}</Moment></small>
                  <p> <div dangerouslySetInnerHTML={{ __html: post?.html?.slice(0, 300) + "..." }} /></p>
                </Link>
              </li>
            ))}
            </ul>
            </div>
          </div>
    );
  }
}
